const genericErrorMessages: { [key: number]: string } = {
  401: 'You are not authorized to perform this action',
  403: 'You are not authorized to perform this action',
  404: 'The requested resource could not be found',
  500: 'An unexpected error occurred. Please try again or contact support.',
};

export default genericErrorMessages;
